import logo from "../../../../public/projects/sattva/logo/logo.png";
import aeropolis from "../../../../public/projects/sattva/projects/Aeropolis.jpg";
import bhumi from "../../../../public/projects/sattva/projects/Bhumi.jpg";
import Forestpridge from "../../../../public/projects/sattva/projects/Forestpridge.jpg";
import lumina from "../../../../public/projects/sattva/projects/Lumina.jpg";

//Forest Ridge
import overviewImage_forestridge from "../../../../public/projects/sattva/images/forestridge/Overview/1.webp";
import bannerDesktopImage_forestridge from "../../../../public/projects/sattva/images/forestridge/Banner/1.webp";
import bannerMobileImage_forestridge from "../../../../public/projects/sattva/images/forestridge/Banner/2.webp";
import siteVisitBannerImage_forestridge from "../../../../public/projects/sattva/images/forestridge/SiteVisitBanner/1.webp";
import Location_forestridge from "../../../../public/projects/sattva/images/forestridge/Location/L1.webp";
import Hightlights_forestridge from "../../../../public/projects/sattva/images/forestridge/Highlights/1.webp";
import image1BHK_forestridge from "../../../../public/projects/sattva/images/forestridge/floorplan/1.webp";
import image2BHK_forestridge from "../../../../public/projects/sattva/images/forestridge/floorplan/2.webp";
import image3BHK_forestridge from "../../../../public/projects/sattva/images/forestridge/floorplan/3.webp";
import location_forestridge from "../../../../public/projects/sattva/images/forestridge/Overview/l.png";
import cal_forestridge from "../../../../public/projects/sattva/images/forestridge/Overview/c.png";
import newlaunch_forestridge from "../../../../public/projects/sattva/images/forestridge/Overview/n.png";
import g1_forestridge from "../../../../public/projects/sattva/images/forestridge/Gallery/1.webp";
import g2_forestridge from "../../../../public/projects/sattva/images/forestridge/Gallery/2.webp";
import g3_forestridge from "../../../../public/projects/sattva/images/forestridge/Gallery/3.webp";
import g4_forestridge from "../../../../public/projects/sattva/images/forestridge/Gallery/4.webp";
import g5_forestridge from "../../../../public/projects/sattva/images/forestridge/Gallery/5.webp";

// Lumina
import overviewImage_lumina from "../../../../public/projects/sattva/images/lumina/Overview/1.webp";
import bannerDesktopImage_lumina from "../../../../public/projects/sattva/images/lumina/Banner/1.webp";
import bannerMobileImage_lumina from "../../../../public/projects/sattva/images/lumina/Banner/2.webp";
import siteVisitBannerImage_lumina from "../../../../public/projects/sattva/images/lumina/SiteVisitBanner/1.webp";
import Location_lumina from "../../../../public/projects/sattva/images/lumina/Location/L1.webp";
import Hightlights_lumina from "../../../../public/projects/sattva/images/lumina/Highlights/1.webp";
import image1BHK_lumina from "../../../../public/projects/sattva/images/lumina/floorplan/1.webp";
import image2BHK_lumina from "../../../../public/projects/sattva/images/lumina/floorplan/2.webp";
import image3BHK_lumina from "../../../../public/projects/sattva/images/lumina/floorplan/3.webp";
import location_lumina from "../../../../public/projects/sattva/images/lumina/Overview/l.png";
import cal_lumina from "../../../../public/projects/sattva/images/lumina/Overview/c.png";
import newlaunch_lumina from "../../../../public/projects/sattva/images/lumina/Overview/n.png";
import g1_lumina from "../../../../public/projects/sattva/images/lumina/Gallery/1.webp";
import g2_lumina from "../../../../public/projects/sattva/images/lumina/Gallery/2.webp";
import g3_lumina from "../../../../public/projects/sattva/images/lumina/Gallery/3.webp";
import g4_lumina from "../../../../public/projects/sattva/images/lumina/Gallery/4.webp";
import g5_lumina from "../../../../public/projects/sattva/images/lumina/Gallery/5.webp";

export const developersSattva = {
  name: `Sattva Properties in Bengaluru `,
  properties: [
    {
      name: "Sattva - Lumina",
      image: lumina,
      price: "On Request",
      location: "Kanakapura Bengaluru",
      projectlocation: "South Bengaluru",
      state: "Bengaluru",
      developer: "Sattva",
      bed: "1 - 2 - 3 BHK Apartments",
      size: "On Request",
      url: `/sattva-lumina-yelahanka-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Sattva - Forest Ridge",
      image: Forestpridge,
      price: "On Request",
      location: "Yelahanka, Bengaluru",
      projectlocation: "North Bengaluru",
      state: "Bengaluru",
      developer: "Sattva",
      bed: "1 - 2 - 3 BHK Apartments",
      size: "On Request",
      url: `/sattva-forest-ridge-jp-nagar-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Sattva - Aeropolis",
      image: aeropolis,
      price: "On Request",
      location: "Bengaluru",
      projectlocation: "Wellesley Road",
      state: "Bengaluru",
      developer: "Sattva",
      bed: "1 - 2 - 3 BHK Apartments",
      size: "656 - 1056 sq.ft.",
      url: ``,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Sattva - Bhumi",
      image: bhumi,
      price: "On Request",
      location: "Bengaluru",
      projectlocation: "Devanahalli, Bengaluru",
      state: "Bengaluru",
      developer: "Sattva",
      bed: "1 - 3 BR Apartments",
      size: "600 - 1799 sq.ft.",
      url: ``,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1993",
  },
  about: `Based in Bengaluru, the diversified real estate giant Sattva Group is renowned for its superior design, high-quality construction, and sustainable practices. It is well-established in Hyderabad, including the well-known Sattva Knowledge City. It is poised to introduce a significant REIT with strong credit ratings and strategic alliances with Apollo Global and Blackstone. Apart from real estate, Sattva is involved in e-commerce infrastructure, data centers, co-living, co-working, warehousing, and education, all of which influence India's changing real estate market.

`,
};

export const projectssattva = {
  forestridge: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_forestridge,
      bannerMobileImage: bannerMobileImage_forestridge,
      textOverlay: "",
      data: {
        title: "SATTVA FOREST RIDGE",
        subtitle: "JP Nagar, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/241224/007315",
        payment_plan: "Under Construction",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "SATTVA FOREST RIDGE",
      description: [
        `Sattva Forest Ridge Apartment on Kanakapura Road is a recently launched residential development that provides premium apartments in the prime area of Kanakapura Road, Bengaluru, Karnataka. With its strategic location, this project is an ideal option for individuals and families eager to create their dream home in a tranquil yet well-connected setting. The contemporary apartments, comprising 1, 2, 2.5, and 3 BHK bedroom configurations, address a variety of needs. Featuring more than 407 residences across eight towers, Sattva Kanakapura Road aims to offer a lively community experience.


`,
      ],
      image: overviewImage_forestridge,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_forestridge,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_forestridge,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_forestridge,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_forestridge,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK",
          area: "732 sq. ft. - 740 sq. ft.",
          price: "On Request",
        },
        {
          type: "2 BHK",
          area: "1197 sq. ft. - 1200 sq. ft.",
          price: "On Request",
        },
        {
          type: "3 BHK",
          area: "1616 sq. ft. - 1859 sq. ft.",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK",
        area: "732 sq. ft. - 740 sq. ft.",
        price: "On Request",

        image: image1BHK_forestridge,
      },
      {
        type: "2 BHK",
        area: "1197 sq. ft. - 1200 sq. ft.",
        price: "On Request",
        image: image2BHK_forestridge,
      },
      {
        type: "3 BHK",
        area: "1616 sq. ft. - 1859 sq. ft.",
        price: "On Request",
        image: image3BHK_forestridge,
      },
    ],

    highlights: {
      images: Hightlights_forestridge,
      tagline: "Highlights",
      features: [
        "1, 2, 2.5 & 3 BHK thoughtfully designed apartments",
        "A 4-acre estate featuring 407 apartments across 2 towers",
        "Residences with spacious private terraces offering views of the green park",
        "Ground level plus 30 additional floors",
        "Breathtaking views of Central Park",
      ],
    },

    location: {
      image: Location_forestridge,
      data: [
        {
          airport: {
            distance_time: "49.7 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "8.1 Km",
            name: "Dayananda Sagar University",
          },
          railwayormetro: {
            distance_time: "13.6 Km",
            name: "Kengeri Station",
          },
          hospital: {
            distance_time: "5 Km",
            name: "Ritu Hospital",
          },
          mall: {
            distance_time: "4.4 Km",
            name: "Forum Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_forestridge },
        { image: g2_forestridge },
        { image: g3_forestridge },
        { image: g4_forestridge },
        { image: g5_forestridge },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in forest ridge, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Sattva - Lumina",
          image: lumina,
          price: "On Request",
          location: "Kanakapura Bengaluru",
          projectlocation: "South Bengaluru",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 2 - 3 BHK Apartments",
          size: "On Request",
          url: `/sattva-lumina-yelahanka-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },

        {
          name: "Sattva - Aeropolis",
          image: aeropolis,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Wellesley Road",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 2 - 3 BHK Apartments",
          size: "656 - 1056 sq.ft.",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Sattva - Bhumi",
          image: bhumi,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Devanahalli, Bengaluru",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 3 BR Apartments",
          size: "600 - 1799 sq.ft.",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  lumina: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_lumina,
      bannerMobileImage: bannerMobileImage_lumina,
      textOverlay: "",
      data: {
        title: "Sattva Lumina",
        subtitle: "Yelahanka, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/060924/007009",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Sattva Lumina",
      description: [
        `Sattva Lumina is a modern luxury apartment project recently launched by Sattva Group, situated in Rajanukunte, Yelahanka, North Bengaluru, close to Kalmi Factory. The project encompasses a land area of 12.83 acres, with 80% dedicated to open spaces. Sattva Rajanukunte Bengaluru features 1553 upscale apartments, including 1, 2, and 3 BHK units. This newly launched Sattva Rajanukunte Lumina comprises 8 high-rise towers with a structure of 2B+G+29 floors, and each level contains between 16 to 5 apartments based on the size of the unit.


`,
      ],
      image: overviewImage_lumina,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_lumina,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_lumina,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_lumina,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_lumina,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "Studio Apartment",
          area: "424 sq. ft.",
          price: "On Request",
        },
        {
          type: "1 BHK",
          area: "690  sq. ft.",
          price: "On Request",
        },
        {
          type: "2 BHK",
          area: "1142 sq. ft.",
          price: "On Request",
        },
        {
          type: "3 BHK",
          area: "1506 sq. ft. - 1809 sq. ft.",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "Studio Apartment",
        area: "424 sq. ft.",
        price: "On Request",
        image: image1BHK_lumina,
      },
      {
        type: "1 BHK",
        area: "690  sq. ft.",
        price: "On Request",
        image: image1BHK_lumina,
      },
      {
        type: "2 BHK",
        area: "1142 sq. ft.",
        price: "On Request",
        image: image2BHK_lumina,
      },
      {
        type: "3 BHK",
        area: "1506 sq. ft. - 1809 sq. ft.",
        price: "On Request",
        image: image3BHK_lumina,
      },
    ],

    highlights: {
      images: Hightlights_lumina,
      tagline: "Highlights",
      features: [
        "Balconies that are 5 feet in width",
        "2 acres dedicated to open space and landscaping",
        "A 45,000 sq. ft. clubhouse featuring top-notch amenities",
        "Serene views of the lake",
        "Expansive and carefully planned 3BHK apartments beginning at 1,700 sq. ft.",
      ],
    },

    location: {
      image: Location_lumina,
      data: [
        {
          airport: {
            distance_time: "20.1 km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "1.9 Km",
            name: "Sai Vidya School",
          },
          railwayormetro: {
            distance_time: "2.1 Km",
            name: "Rajanukunte Station",
          },
          hospital: {
            distance_time: "450 m",
            name: "Chiguru Hospital",
          },
          mall: {
            distance_time: "9.7 Km",
            name: "Garuda Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_lumina },
        { image: g2_lumina },
        { image: g3_lumina },
        { image: g4_lumina },
        { image: g5_lumina },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in sattva lumina, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Sattva - Forest Ridge",
          image: Forestpridge,
          price: "On Request",
          location: "Yelahanka, Bengaluru",
          projectlocation: "North Bengaluru",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 2 - 3 BHK Apartments",
          size: "On Request",
          url: `/sattva-forest-ridge-jp-nagar-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Sattva - Aeropolis",
          image: aeropolis,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Wellesley Road",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 2 - 3 BHK Apartments",
          size: "656 - 1056 sq.ft.",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Sattva - Bhumi",
          image: bhumi,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Devanahalli, Bengaluru",
          state: "Bengaluru",
          developer: "Sattva",
          bed: "1 - 3 BR Apartments",
          size: "600 - 1799 sq.ft.",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
